import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useTeacherCourses({ enabled = true } = {}) {
  const { privateFetch } = useContext(FetchContext);

  const getCourses = async () => {
    try {
      const res = await privateFetch.get('/v1/admin/teacher/courses');

      const courses =
        res?.data?.data?.result || res?.data?.data || res?.data?.result || res?.data || [];

      return Array.isArray(courses) ? courses : [];
    } catch (error) {
      console.error('Error fetching teacher courses:', error);
      return [];
    }
  };

  return useQuery(['teacher-courses'], getCourses, {
    enabled,
    keepPreviousData: true,
    staleTime: 30000,
    retry: 1,
  });
}

export default useTeacherCourses;
